
export default function ESGCarbon() {
  return (
    <section id="esg-carbon" className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-[38px] font-semibold text-[#111111]">
            ESG &amp; Carbon Markets Advisory
          </h2>
          <p className="mt-4 text-[17px] text-[#666666] max-w-[700px] mx-auto">
            Strategic guidance and market intelligence for navigating carbon credits and ESG opportunities in Asia.
          </p>
        </div>

        {/* Main Advisory Points */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-[#FAFAFA] border border-gray-200 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-[#B11226]/10 rounded-xl mb-5">
              <i className="ri-line-chart-line text-2xl text-[#B11226]"></i>
            </div>
            <h3 className="text-[19px] font-semibold text-[#111111] mb-3">
              Carbon Credits Market Intelligence
            </h3>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Opportunity mapping, market trends analysis, and strategic positioning in voluntary carbon markets across Asia-Pacific.
            </p>
          </div>

          <div className="bg-[#FAFAFA] border border-gray-200 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-[#B11226]/10 rounded-xl mb-5">
              <i className="ri-shield-check-line text-2xl text-[#B11226]"></i>
            </div>
            <h3 className="text-[19px] font-semibold text-[#111111] mb-3">
              Quality Criteria &amp; Project Screening
            </h3>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Overview-level guidance on VCS/Gold Standard frameworks, project evaluation, and quality assessment criteria.
            </p>
          </div>

          <div className="bg-[#FAFAFA] border border-gray-200 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-[#B11226]/10 rounded-xl mb-5">
              <i className="ri-file-list-3-line text-2xl text-[#B11226]"></i>
            </div>
            <h3 className="text-[19px] font-semibold text-[#111111] mb-3">
              Registry &amp; Standards Guidance
            </h3>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Non-regulated advisory on documentation requirements, registry processes, and standards compliance considerations.
            </p>
          </div>

          <div className="bg-[#FAFAFA] border border-gray-200 rounded-2xl p-8">
            <div className="w-12 h-12 flex items-center justify-center bg-[#B11226]/10 rounded-xl mb-5">
              <i className="ri-search-eye-line text-2xl text-[#B11226]"></i>
            </div>
            <h3 className="text-[19px] font-semibold text-[#111111] mb-3">
              Due Diligence Support
            </h3>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Risk awareness on claims, communication strategies, and independent analysis to support informed decision-making.
            </p>
          </div>
        </div>

        {/* Use Cases */}
        <div className="bg-gradient-to-br from-[#FAFAFA] to-white border border-gray-200 rounded-2xl p-8">
          <h4 className="text-[17px] font-semibold text-[#111111] mb-6 text-center">
            Use Cases
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-white border border-gray-200 rounded-xl mx-auto mb-3">
                <i className="ri-building-line text-2xl text-[#B11226]"></i>
              </div>
              <p className="text-[14px] font-medium text-[#111111] mb-2">Corporate Buyers</p>
              <p className="text-[13px] text-[#666666] leading-relaxed">Support in sourcing strategy, supplier mapping and market intelligence.</p>
            </div>
            <div className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-white border border-gray-200 rounded-xl mx-auto mb-3">
                <i className="ri-exchange-line text-2xl text-[#B11226]"></i>
              </div>
              <p className="text-[14px] font-medium text-[#111111] mb-2">Brokers</p>
              <p className="text-[13px] text-[#666666] leading-relaxed">Strategic positioning and regional network development support.</p>
            </div>
            <div className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-white border border-gray-200 rounded-xl mx-auto mb-3">
                <i className="ri-plant-line text-2xl text-[#B11226]"></i>
              </div>
              <p className="text-[14px] font-medium text-[#111111] mb-2">Project Developers</p>
              <p className="text-[13px] text-[#666666] leading-relaxed">Market access advisory and carbon standards navigation across Asia-Pacific.</p>
            </div>
            <div className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-white border border-gray-200 rounded-xl mx-auto mb-3">
                <i className="ri-funds-line text-2xl text-[#B11226]"></i>
              </div>
              <p className="text-[14px] font-medium text-[#111111] mb-2">Investors</p>
              <p className="text-[13px] text-[#666666] leading-relaxed">Independent screening, due diligence support and market intelligence insights.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}